import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css/normalize.css';
import 'react-flexbox-grid/dist/react-flexbox-grid.css';
import './index.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import Amplify from 'aws-amplify'
import { ToastProvider } from 'react-toast-notifications'
import { AuthProvider } from './contexts/auth'
import config from './config'
import 'react-day-picker/lib/style.css';

import Storage from '@aws-amplify/storage';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

  Auth.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID
    }
  });

  API.configure({
    endpoints: [
      {
        name: 'cognito',
        endpoint: `${config.apiGateway.URL}/cognito${config.apiGateway.STAGE_IN_PATH === false ? '' : '/latest'}`,
        region: config.apiGateway.REGION
      },
      {
        name: 'parvoalert',
        endpoint: `${config.apiGateway.URL}/parvoalert${config.apiGateway.STAGE_IN_PATH === false ? '' : '/latest'}`,
        region: config.apiGateway.REGION
      }
    ]
  });

  Storage.configure(
    {
      AWSS3: {
        region: config.s3.REGION,
        bucket: config.s3.BUCKET,
        identityPoolId: config.cognito.IDENTITY_POOL_ID
      }
    }
  );

// Amplify.configure({
//   Auth: {
//     mandatorySignIn: true,
//     region: config.cognito.REGION,
//     userPoolId: config.cognito.USER_POOL_ID,
//     userPoolWebClientId: config.cognito.APP_CLIENT_ID
//   },
//   Storage: {
//     region: config.s3.REGION,
//     bucket: config.s3.BUCKET,
//     identityPoolId: config.cognito.IDENTITY_POOL_ID
//   },
//   API: {
//     endpoints: [
//       {
//         name: 'cognito',
//         endpoint: `${config.apiGateway.URL}/cognito/latest`,
//         region: config.apiGateway.REGION
//       },
//       {
//         name: 'parvoalert',
//         endpoint: `${config.apiGateway.URL}/parvoalert/latest`,
//         region: config.apiGateway.REGION
//       }
//     ]
//   }
// })

ReactDOM.render(
  <ToastProvider
    PlacementType='top-center'
  >
    <AuthProvider>
      <App />
    </AuthProvider>
  </ToastProvider>, 
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
